export function PageHeader({ title, description }: { title: string; description?: string }) {
  return (
    <header className="border-line mb-8 border-b pb-5">
      {/* Short burgundy rule: the one piece of pure brand on an otherwise
          data-first page, borrowed from the section marks on the public site. */}
      <span className="bg-brand mb-3 block h-[3px] w-8" aria-hidden />
      <h1 className="font-display text-ink text-[26px] leading-tight">{title}</h1>
      {description && <p className="text-muted mt-2 text-sm leading-relaxed">{description}</p>}
    </header>
  )
}
